import Vue from 'vue';

export default ({ app }) => {
    // 1. Vue internal errors
    Vue.config.errorHandler = (error, vm, info) => {
        console.error('[Vue Error Handler]', error, vm, info);

        app.$sentry.captureException(error, {
            extra: {
                info,
                componentName: vm?.$options?.name,
                routeInfo:
                    vm && vm.$route
                        ? {
                              name: vm.$route.name,
                              path: vm.$route.path,
                              query: vm.$route.query,
                              params: vm.$route.params
                          }
                        : {},
                componentData: vm?.$data,
                storeState: app?.store?.state
            }
        });
    };

    if (process.client) {
        // 2. Global JS errors
        window.onerror = (message, source, lineno, colno, error) => {
            console.error('[Window OnError]', message, source, lineno, colno, error);

            // "error" может быть null
            const errObj = error || new Error(message);

            app.$sentry.captureException(errObj, {
                extra: {
                    source,
                    lineno,
                    colno
                }
            });
        };

        // 3. Unhandled Promise Rejections
        window.addEventListener('unhandledrejection', event => {
            console.error('[Unhandled Rejection]', event.reason);
            // event.reason - это объект ошибки (или что-то, что было "выброшено")

            app.$sentry.captureException(event.reason);
        });

        // 4. Resource loading errors
        window.addEventListener(
            'error',
            event => {
                // Проверяем, не ошибка ли это загрузки ресурса (<script>, <img>, <link> и т.д.)
                const target = event.target;
                if (target && (target.src || target.href)) {
                    const url = target.src || target.href;
                    console.error('[Resource Load Error]', url);

                    app.$sentry.captureException(new Error(`Resource failed to load: ${url}`), {
                        extra: {
                            tagName: target.tagName,
                            resourceUrl: url
                        }
                    });
                }
            },
            true
        );
    }
};
